import React from 'react';

import StageBanner from '../StageBanner/StageBanner';
import StageContent from '../StageContent/StageContent';
import FormActionBar from '../FormActionBar/FormActionBar';
import CycleDetailHeader from '../CycleDetailHeader/CycleDetailHeader';

const CycleMainPanel = ({
    cycleData,
    formData,
    setFormData,
    handleReloadFormData,
    handleSaveStageChanges,
    saveChangesButtonState,
    expandedGroups,
    setExpandedGroups,
    backLinkHref,
}) => {
    const { name, current_stage } = cycleData;
    const { type, stage_status, default_version } = current_stage;

    const status = stage_status?.status_key;
    const details = default_version.details;
    const title = details?.title;

    return (
        <div className="relative flex-grow min-h-full lg:px-6 min-[1800px]:px-8 lg:pt-5 pb-[40px] lg:pb-[60px] flex flex-col items-start gap-5 overflow-y-auto bg-white">
            <CycleDetailHeader backLinkHref={backLinkHref} name={name} stage={current_stage} />

            <div className="w-full px-4 xs:px-5 md:px-6 lg:p-0 flex flex-col gap-5 bg-white">
                <StageBanner stage={current_stage} />

                <div className="flex flex-col gap-6 lg:gap-5 py-5 xs:px-2 lg:py-2 xl:px-4">
                    {title && (
                        <h2 className="font-heading-bold text-heading-bold-m text-black">
                            {title}
                        </h2>
                    )}

                    <StageContent
                        stage={current_stage}
                        formData={formData}
                        setFormData={setFormData}
                        expandedGroups={expandedGroups}
                        setExpandedGroups={setExpandedGroups}
                    />
                </div>
            </div>

            <FormActionBar
                status={status}
                type={type}
                handleReloadFormData={() => handleReloadFormData(current_stage)}
                handleSaveStageChanges={handleSaveStageChanges}
                saveChangesButtonState={saveChangesButtonState}
            />
        </div>
    );
};

export default CycleMainPanel;
